import NewOrders from "./components/newOrders";

export default NewOrders;